import type { IconDefinition } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import type { ToOptions } from '@tanstack/react-router'
import type { MouseEvent, ReactElement } from 'react'
import { Tooltip } from '~/components/Global/Elements/Tooltip/Tooltip'
import { Button } from '~/components/Global/Interactions/Button/Button'
import { ButtonVariation } from '~/components/Global/Interactions/Button/ButtonVariation'
import { rowActionsItem } from './DataTable.css'

type DataTableRowActionProps = {
  icon: IconDefinition
  label: string
  disabled?: boolean
  disabledReason?: string
  onClick?: () => void
  href?: string
  link?: ToOptions
  target?: string
  rel?: string
}

export const DataTableRowAction = ({
  icon,
  label,
  disabled = false,
  disabledReason,
  onClick,
  href,
  link,
  target,
  rel
}: DataTableRowActionProps): ReactElement => {
  const handleClick = (
    e: MouseEvent<HTMLButtonElement & HTMLAnchorElement>
  ) => {
    e.stopPropagation()
    if (disabled) {
      e.preventDefault()
      return
    }
    onClick?.()
  }

  const isLink = !disabled && (!!href || !!link)
  const linkRel =
    target === '_blank' ? [rel, 'noopener'].filter(Boolean).join(' ') : rel

  return (
    <Tooltip
      text={disabled ? (disabledReason ?? label) : label}
      direction="top"
      asChild
    >
      <span className={rowActionsItem}>
        <Button
          buttonSize="small"
          variation={disabled ? ButtonVariation.Light : ButtonVariation.Primary}
          narrow
          shrink
          type={isLink ? undefined : 'button'}
          disabled={disabled}
          aria-label={label}
          href={disabled ? undefined : href}
          link={disabled ? undefined : link}
          target={isLink ? target : undefined}
          rel={isLink ? linkRel : undefined}
          onClick={handleClick}
        >
          <FontAwesomeIcon icon={icon} />
        </Button>
      </span>
    </Tooltip>
  )
}
